import { InferType } from 'yup'
import { featureGridBlockSchema } from './featureGridBlockSchema'

export const featureBento1BlockSchema = featureGridBlockSchema

export type FeatureBento1Block = InferType<typeof featureBento1BlockSchema>
